import { render, staticRenderFns } from "./TextPart.vue?vue&type=template&id=f35a011e&"
import script from "./TextPart.vue?vue&type=script&lang=js&"
export * from "./TextPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports